module.exports = __webpack_public_path__ + "img/222A0842.78274592.png";